import React from 'react'
import { Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { getImage } from 'gatsby-plugin-image'
import TestimonialsThreePart from './parts/TestimonialsThreePart.js'
import AnimatedHeading from 'components/animated-heading'

class TestimonialsThree extends React.Component {
  render() {
    const Section = styled.section`
      position: relative;
      overflow: hidden;
      background-color: #000;
      background-size: cover;
    `

    const TestimonialContainer = styled.div`
      padding: 50px 0;
      @media (max-width: 767px) {
        padding: 50px 10px;
      }
    `

    // Obtener imágenes de comillas con getImage
    const quotationUpImage = getImage(this.props.quotation_up)
    const quotationDownImage = getImage(this.props.quotation_down)

    return (
      <Section id="testimonios">
        <TestimonialContainer>
          <Container>
            <AnimatedHeading text="Lo dicen ellos" />

            

            <TestimonialsThreePart
              testimonials={this.props.testimonials}
              quotation_up={quotationUpImage}
              quotation_down={quotationDownImage}
            />
          </Container>
        </TestimonialContainer>
      </Section>
    )
  }
}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      query {
        quotation_up: file(relativePath: { eq: "quotation-up.png" }) {
          childImageSharp {
            gatsbyImageData(width: 500, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP, AVIF])
          }
        }
        quotation_down: file(relativePath: { eq: "quotation-down.png" }) {
          childImageSharp {
            gatsbyImageData(width: 500, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP, AVIF])
          }
        }
        testimonials: allMarkdownRemark(
          filter: { fileAbsolutePath: { regex: "/(testimonials)/" } }
          sort: { fields: [frontmatter___id], order: ASC }
        ) {
          edges {
            content: node {
              frontmatter {
                id
                name
                profession
                text
                image {
                  childImageSharp {
                    gatsbyImageData(width: 200, height: 200, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP])
                  }
                }
                large {
                  childImageSharp {
                    gatsbyImageData(width: 2000, height: 2000, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP])
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={({ quotation_up, quotation_down, testimonials }) => (
      <TestimonialsThree
        quotation_up={quotation_up.childImageSharp.gatsbyImageData}
        quotation_down={quotation_down.childImageSharp.gatsbyImageData}
        testimonials={testimonials.edges}
        {...props}
      />
    )}
  />
)

export default Iconos